import React from "react"
import QuotesImg from "../../images/quote-black.png"
import parse from "html-react-parser"
import { Grid } from "@mui/material"

import * as S from "./case-study-testimonial.styles.jsx"

const CaseStudyTestimonial = ({
  columns,
  title,
  content,
  author,
  testimonial,
}) => {
  return (
    <S.Section>
      <S.Wrapper>
        {title && <S.Title>{parse(title)}</S.Title>}
        {columns && (
          <Grid container spacing={4}>
            {columns.map((column, index) => (
              <Grid key={`case-study-${index}`} item md={3}>
                <S.Column>
                  <h3>{column.result}</h3>
                  <p>{column.text}</p>
                </S.Column>
              </Grid>
            ))}
          </Grid>
        )}
        {/*{content && <S.TextWrapper maxWidth="md">{content}</S.TextWrapper>}*/}

        {testimonial && (
          <S.TestimonialWrapper>
            <S.ImageContainer>
              <S.Quotes img={QuotesImg} alt="quote" />
            </S.ImageContainer>
            <S.TestimonialContainer>
              <S.Testimonial>{testimonial}</S.Testimonial>
            </S.TestimonialContainer>
          </S.TestimonialWrapper>
        )}

        {author && (
          <S.AuthorContainer container spacing={2} alignItems="center">
            {author.image && (
              <S.AuthorImageContainer item>
                <S.AuthorImage img={author.image} />
              </S.AuthorImageContainer>
            )}
            <Grid item>
              <S.AuthorName>
                <strong>{author.name}</strong>
              </S.AuthorName>
              <S.Role>{author.role}</S.Role>
            </Grid>
          </S.AuthorContainer>
        )}
      </S.Wrapper>
    </S.Section>
  )
}
export default CaseStudyTestimonial
